/**
 * ショットの media_file（一番上のメディアアイテムの原本 URL）から
 * 種別を拡張子で判定するためのヘルパー。
 *
 * ShotPortraitCard の cover フォールバックと WaitingShotCloud のチップが
 * 同じ規則を共有する（判定リストは ProjectWheel と同じ）。
 */

/** 背景動画として扱う拡張子。 */
export const VIDEO_EXTENSIONS = ["mp4", "webm", "mov", "m3u8"];
/** cover として直接表示できる画像拡張子。 */
export const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp", "svg", "bmp"];
/** オーディオとして扱う拡張子。 */
export const AUDIO_EXTENSIONS = ["mp3", "wav", "aac", "m4a", "ogg", "flac"];

/** URL の拡張子（クエリ除去・小文字）。無ければ空文字。 */
export const extOfUrl = (url: string | null | undefined): string =>
  url ? url.split("?")[0].split(".").pop()?.toLowerCase() ?? "" : "";
